import { createQueryKeys } from '@lukemorales/query-key-factory';

import API from '../../index';
import { GetCategoriesRequestParams } from './category.types';

export const categoryQueryKeys = createQueryKeys('category', {
  getCategories: (params: GetCategoriesRequestParams) => ({
    queryKey: [{ params }],
    queryFn: () => API.Category.getCategories(params),
  }),
});
